/**
 * Builds a IAB USP v1 string for the SDK-installed `__uspapi` stub.
 *
 *   '1' + notice + opt-out + LSPA
 *
 * - notice = 'Y' (we always treat the user as having been given notice — they
 *   either landed on the site, or interacted with the host's opt-out link).
 * - opt-out = 'Y' if `ccpa_opt_out=1`, else 'N'.
 * - LSPA = '-' (not signatory).
 *
 * Outside CCPA jurisdictions we return '1---' (CCPA does not apply).
 */

export function buildUspString(args: { ccpaApplicable: boolean; optedOut: boolean }): string {
  if (!args.ccpaApplicable) return '1---';
  return args.optedOut ? '1YY-' : '1YN-';
}
